<template>
    <footer class="footer">
        <p class="has-text-centered">Copyright (c) 2022 ScaleUpUSA</p>
    </footer>
</template>